import { Info } from "lucide-react";

import { compraDe, usoDe } from "../lib/unidade";

/** Uma frase, no rodape do dialog, dizendo o que ficou configurado. */
export default function ResumoUnidade({ value }) {
  const compra = compraDe(value);
  if (!compra) return null;
  const uso = usoDe(value);
  const peso = Number(value.unitWeight) || 0;
  const n = Number(value.unitsPerPackage) || 0;
  const partes = [];
  if (compra === "caixa") partes.push(n > 0 ? `compra em caixa de ${n}` : "compra em caixa");
  else partes.push(compra === "kg" ? "compra em kg" : "compra por unidade");
  partes.push(`estoque em ${compra === "kg" ? "kg" : "unidades"}`);
  partes.push(`ficha em ${uso === "kg" ? "kg" : "unidades"}`);
  if (peso > 0 && compra !== "caixa" && uso !== (compra === "kg" ? "kg" : "un")) partes.push(`1 un = ${peso.toFixed(3).replace(".", ",")} kg`);
  return (
    <p className="flex items-center gap-1.5 text-xs text-muted-foreground" data-e2e="resumo-unidade">
      <Info className="w-3.5 h-3.5 shrink-0" />
      <span>{partes.join(" · ")}</span>
    </p>
  );
}
